import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Instagram } from "lucide-react";
import { useData } from "@/context/DataContext";

export default function Footer() {
  const { settings } = useData();
  const phone = settings?.phone || "207-773-8000";
  const social = settings?.social || {};
  return (
    <footer className="bg-[#0A2818] border-t border-emerald-800/40 tropical-grain">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-3">
            {settings?.logo_image && (
              <span className="grid place-items-center w-14 h-14 rounded-full bg-white overflow-hidden ring-2 ring-amber-400/60 shrink-0">
                <img src={settings.logo_image} alt="Sir. King Kitchen logo" className="w-full h-full object-contain" />
              </span>
            )}
            <div className="font-display font-black text-2xl">
              <span className="text-amber-400">Sir. King</span> Kitchen
            </div>
          </div>
          <p className="text-[#FDFBF7]/70 max-w-sm leading-relaxed">
            Authentic Jamaican flavor. Maine made. Bold Caribbean food, family recipes, and Maine hospitality —
            {" "}{settings?.service_area_note || "Serving all of New England"}.
          </p>
          <div className="flex gap-3 mt-5">
            {social.instagram && (
              <a data-testid="social-instagram" href={`https://instagram.com/${social.instagram}`} target="_blank" rel="noreferrer"
                 className="grid place-items-center w-10 h-10 rounded-full bg-emerald-900/70 text-amber-300 hover:bg-amber-400 hover:text-[#0A2818] transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            )}
            {social.tiktok && (
              <a data-testid="social-tiktok" href={`https://tiktok.com/@${social.tiktok}`} target="_blank" rel="noreferrer"
                 className="grid place-items-center w-10 h-10 rounded-full bg-emerald-900/70 text-amber-300 hover:bg-amber-400 hover:text-[#0A2818] transition-colors">
                <i className="fa-brands fa-tiktok" />
              </a>
            )}
            {social.snapchat && (
              <a data-testid="social-snapchat" href={`https://snapchat.com/add/${social.snapchat}`} target="_blank" rel="noreferrer"
                 className="grid place-items-center w-10 h-10 rounded-full bg-emerald-900/70 text-amber-300 hover:bg-amber-400 hover:text-[#0A2818] transition-colors">
                <i className="fa-brands fa-snapchat" />
              </a>
            )}
          </div>
        </div>

        <div>
          <h4 className="font-display font-bold uppercase tracking-wider text-amber-400 mb-4">Explore</h4>
          <ul className="space-y-2 text-[#FDFBF7]/75">
            <li><Link to="/menu" className="hover:text-amber-300">Menu</Link></li>
            <li><Link to="/catering" className="hover:text-amber-300">Catering</Link></li>
            <li><Link to="/story" className="hover:text-amber-300">Our Story</Link></li>
            <li><Link to="/delivery-pickup" className="hover:text-amber-300">Delivery & Pickup</Link></li>
            <li><Link to="/track" className="hover:text-amber-300">Track Order</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold uppercase tracking-wider text-amber-400 mb-4">Reach Us</h4>
          <a href={`tel:${phone.replace(/[^0-9]/g, "")}`} className="flex items-center gap-2 text-[#FDFBF7]/75 hover:text-amber-300 mb-2">
            <Phone className="w-4 h-4" /> {phone}
          </a>
          <a href={`https://maps.google.com/?q=${encodeURIComponent(settings?.address || "135 Congress St, Portland, ME 04101")}`} target="_blank" rel="noreferrer" className="flex items-start gap-2 text-[#FDFBF7]/75 hover:text-amber-300 mb-2">
            <MapPin className="w-4 h-4 mt-1 shrink-0" /> {settings?.address || "135 Congress St, Portland, ME 04101"}
          </a>
          <div className="text-xs text-[#FDFBF7]/50">{settings?.service_area_note || "Serving all of New England"}</div>
        </div>
      </div>
      <div className="border-t border-emerald-800/40 py-5 text-center text-xs text-[#FDFBF7]/50">
        © {new Date().getFullYear()} Sir. King Kitchen · Jamaican Food & Catering · Maine
      </div>
    </footer>
  );
}
